///* eslint-disable */
import React, { useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import { useState, Downgraded } from '@hookstate/core';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import RouteConstants from '../../constants/routeConstants';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import DataList from '../../sharedcomponents/dataList/dataList';
import Helper from '../../utility/helper';
import { useHistory, generatePath } from 'react-router-dom';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import { setNotification } from '../../hookState/NotifcationState';

const useStyles = makeStyles(() => ({
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
}));

const AppNotifications = () => {
    const classes = useStyles();
    const loading = useState(false);
    const notificationList = useState(null);
    const userInfo = Helper.getStorage('userInfo');
    const eventInfo = Helper.getStorage('eventInfo');
    // const allData = useState(false);
    const history = useHistory();

    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });

    useEffect(() => {
        getInAppNotifications();
    }, []);

    const getInAppNotifications = () => {
        loading.set(true);
        const gAgentInfo = Helper.getStorage('agentUser');
        const agentConnection = Helper.getStorage('agentConnections');
        const userInfo = Helper.getStorage('userInfo');
        ApiHelper.get(APIURLConstants.GET_APP_NOTIFICATIONS(agentConnection && gAgentInfo ? gAgentInfo.userID : userInfo.userID
        ))
            .then((res) => {
                let newData = res.data;
                let notifyData = [];
                // newData.map(item => item.selected = false);
                if (newData.length > 0) {
                    newData.map((item) => {
                        let notify = getNotifyText(item);

                        notifyData.push({
                            actualData: item,
                            row: [
                                {
                                    label: 'checkbox',
                                    key: 'appNotificationID',
                                    appNotificationID: item.appNotificationID,
                                    width: '0.05',
                                    inColumn: true,
                                    alignCenter: true,
                                },
                                {
                                    label: '',
                                    key: 'appNotification',
                                    statusKey: 'appNotificationStatus',
                                    appNotification: notify,
                                    appNotificationStatus:
                                        item.appNotificationTypeID === 1
                                            ? item.requestStatus === 1
                                                ? 'pending'
                                                : item.requestStatus === 2
                                                    ? 'approved'
                                                    : 'rejected'
                                            : null,
                                    width: '0.9',
                                    showLabel: false,
                                    inColumn: true,
                                },
                                {
                                    label: 'ReadAction',
                                    key: 'read',
                                    read: item.status,
                                    width: '0.1',
                                },
                            ],
                            selected: false,
                        });
                    });
                }
                notificationList.set(notifyData);
                loading.set(false);
            })
            .catch((error) => {
                if (error.response && error.response.status === 401) {
                    console.log(error);
                }
                loading.set(false);
            });
    };
    const getAppNotificationCount = () => {
        const userInfo = Helper.getStorage('userInfo');
        // console.log("userInfo", userInfo);
        ApiHelper.get(
            APIURLConstants.GET_APP_NOTIFICATION_COUNT(userInfo.userID)
        )
            .then((res) => {
                // setAppNotificationCount(res.data)
                setNotification({ notificationCount: res.data });
            })
            .catch((err) => {
                console.log(err);
            });
    };
    const getNotifyText = (item) => {
        let eventName = item.eventName;
        let moduleName = item.moduleName;
        // let requestStatus =
        //     item.requestStatus === 1
        //         ? 'pending'
        //         : item.requestStatus === 2
        //             ? 'approved'
        // : 'rejected';
        let yourConnectionName =
            item.connectionName !== '' ? item.connectionName : 'Your';
        let youConnectionName =
            item.connectionName !== '' ? item.connectionName : 'you';
        let resourceName = item.resourceName ? item.resourceName : '';
        let notifyText;
        // console.log(item.appNotificationTypeID);
        switch (item.appNotificationTypeID) {
            case 1:
                notifyText = `${eventName}:  ${yourConnectionName} ${moduleName === 'DraftHotel' ? 'PlayerHotel' : moduleName
                    } Request  is`;
                break;
            case 2:
                notifyText = `${eventName}: Event admin has shared new resource ${resourceName} with ${youConnectionName}`;
                break;
            case 3:
                notifyText = `${eventName}: Schedule is shared with ${youConnectionName}`;
                break;
            case 5:
                notifyText = `${eventName}: Schedule is Unpublished `;
                break;
            case 6:
                notifyText = `${eventName}: Staff Schedule is Published `;
                break;
            case 7:
                notifyText = `${eventName}: Staff Schedule is Unpublished `;
                break;
            case 8:
                notifyText = `${eventName}: there is a note for you `;
                break;
            default:
                notifyText = `${eventName}: is published please visit`;
                break;
        }
        return notifyText;
    };
    const onDelete = () => {
        const selected = notificationList
            .get()
            .filter((notification) => notification.selected === true);
        if (selected.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select notification first',
            });
        } else {
            let message =
                selected.length === notificationList.get().length
                    ? 'Do you want to delete all notification?'
                    : 'Do you want to delete selected notification?';
            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };

    const handleConfirmation = () => {
        let deleteRequests = [];
        // let allData = [];
        notificationList.get().map((row) => {
            if (row.selected === true) {
                deleteRequests.push(row.actualData.appNotificationID);
            }
        });

        ApiHelper.post(APIURLConstants.DELETE_APP_NOTIFICATIONS, {
            appNotificationIDs: deleteRequests.join(','),
            ModifiedBy: userInfo.userID,
        })
            .then((res) => {
                if (res.data) {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request deleted successfully',
                    });
                    getInAppNotifications();
                    getAppNotificationCount()
                    // props.onDelete(false);
                    // setAll.set(false);
                    // getAdminHotelRequestList();
                    //getEmailNotification();
                }
            })
            .catch((error) => {
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while deleting request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };

    const updateNotifications = (val) => {
        const selected = notificationList
            .get()
            .filter((notification) => notification.selected === true);
        if (selected.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select notification first',
            });
            return 0;
        }
        let updateRequests = [];
        notificationList.get().map((row) => {
            if (row.selected === true) {
                updateRequests.push(row.actualData.appNotificationID);
            }
        });

        ApiHelper.post(APIURLConstants.UPDATE_APP_NOTIFICATIONS, {
            appNotificationIDs: updateRequests.join(','),
            status: val,
            ModifiedBy: userInfo.userID,
        })
            .then((res) => {
                if (res.data) {
                    getAppNotificationCount();
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request processed successfully',
                    });
                    getInAppNotifications();
                    // props.onDelete(false);
                    // setAll.set(false);
                    // getAdminHotelRequestList();
                    //getEmailNotification();
                }
            })
            .catch((error) => {
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while deleting request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
    };
    const handleAppNotificationClick = async (item) => {
        if (item.connectionName != '') {
            ApiHelper.get(APIURLConstants.GET_EVENT(item.eventID, 0)).then(
                (res) => {
                    if (res.data) {
                        const eventData = res.data;
                        // console.log('event : ', res);
                        Helper.setStorage('eventInfo', eventData);
                        ApiHelper.get(
                            APIURLConstants.GET_EVENT_CONFIG(item.eventID)
                        ).then((res) => {
                            Helper.setStorage('eventModuleConfig', res.data);
                        });

                        const gUserInfo = Helper.getStorage('userInfo');
                        Helper.setStorage('agentInfo', gUserInfo);
                        let path = generatePath(
                            RouteConstants.EVENT_AGENT_PROFILE,
                            {
                                eventID: item.eventID,
                            }
                        );

                        history.push({
                            pathname: path,
                            state: { event: eventData },
                        });
                    }
                }
            );
        } else {
            let pathName = getModulePath(item);

            if (pathName != null) {
                const userEvents = Helper.getStorage('UserEvents');
                let data;
                if (eventInfo === null) {
                    data =
                        userEvents &&
                        userEvents.filter(
                            (event) => event.eventID === item.eventID
                        );
                    //added below to fetch modulesDetails
                    if (data && data[0] && !data[0].moduleDetails) {
                        let moduleDetailResult = await ApiHelper.get(APIURLConstants.GET_EVENT_MODULE_DETAILS(item.eventID));
                        if (moduleDetailResult) {
                            data[0].moduleDetails = moduleDetailResult.data;
                        }
                    }
                    if (data) {
                        Helper.setStorage('eventInfo', data[0]);
                    }
                    history.push({
                        pathname: pathName,
                        state: { displayName: item.moduleName }
                    });
                } else {

                    if (eventInfo && eventInfo.eventID !== item.eventID) {
                        const event = ApiHelper.get(
                            APIURLConstants.GET_EVENT(item.eventID, 0)
                        );
                        const eventConfig = ApiHelper.get(
                            APIURLConstants.GET_EVENT_CONFIG(
                                item.eventID
                            )
                        );
                        await Promise.all([event, eventConfig]).then((result) => {
                            const eventData = result[0].data;
                            Helper.setStorage('eventInfo', eventData);

                            Helper.setStorage('eventModuleConfig', result[1].data);

                            history.push({
                                pathname: pathName,
                                state: { displayName: item.moduleName }
                            });

                        }).catch(err => {
                            console.log('error while fetching Event Info', err);
                        });
                    }
                    else {
                        history.push({
                            pathname: pathName,
                            state: { displayName: item.moduleName }
                        });
                    }
                }
                location.reload();
            }
        }
    };

    const getModulePath = (item) => {
        let path = item.moduleID === 1
            ? generatePath(RouteConstants.EVENT_TRANSIT, {
                eventID: item.eventID,
            })
            : item.moduleID === 2
                ? generatePath(RouteConstants.EVENT_REGISTER_CREATE, {
                    eventID: item.eventID,
                })
                : item.moduleID === 3
                    ? generatePath(RouteConstants.EVENT_INVITATIONS, {
                        eventID: item.eventID,
                    })
                    : item.moduleID === 4
                        ? generatePath(RouteConstants.EVENT_HOTEL, {
                            eventID: item.eventID,
                        })
                        : item.moduleID === 5
                            ? generatePath(RouteConstants.EVENT_OUTFIT, {
                                eventID: item.eventID,
                            })
                            : item.moduleID === 6
                                ? generatePath(
                                    RouteConstants.EVENT_DRAFT_REGISTRATION_LIST,
                                    {
                                        eventID: item.eventID,
                                    }
                                )
                                : item.moduleID === 7
                                    ? generatePath(RouteConstants.EVENT_ALLSTAR_HOTEL, {
                                        eventID: item.eventID,
                                    })
                                    : item.moduleID === 22
                                        ? generatePath(RouteConstants.EVENT_DRAFT_HOTEL, {
                                            eventID: item.eventID,
                                        })
                                        : item.appNotificationTypeID === 8
                                            ? generatePath(RouteConstants.EVENT_NOTES_USER, {
                                                eventID: item.eventID,
                                            })
                                            : item.moduleID === 8
                                                ? generatePath(RouteConstants.EVENT_TICKETS, {
                                                    eventID: item.eventID,
                                                })
                                                : item.moduleID === 9
                                                    ? generatePath(RouteConstants.EVENT_DETAIL, {
                                                        eventID: item.eventID,
                                                    })
                                                    : item.moduleID === 10
                                                        ? generatePath(RouteConstants.EVENT_SCHEDULE, {
                                                            eventID: item.eventID,
                                                        })
                                                        : item.moduleID === 11
                                                            ? generatePath(RouteConstants.EVENT_RESOURCE, {
                                                                eventID: item.eventID,
                                                            })
                                                            : item.moduleID === 12
                                                                ? generatePath(
                                                                    RouteConstants.EVENT_SAT_NIGHT_TRANSPORT_ENDUSER_CREATE,
                                                                    {
                                                                        eventID: item.eventID,
                                                                    }
                                                                )
                                                                : item.moduleID === 23
                                                                    ? generatePath(
                                                                        RouteConstants.PRIVATE_VEHICLE_ENDUSER_CREATE,
                                                                        {
                                                                            eventID: item.eventID,
                                                                        }
                                                                    )
                                                                    : item.moduleID === 13
                                                                        ? generatePath(RouteConstants.CREATE_EVENT_VIP, {
                                                                            eventID: item.eventID,
                                                                        })
                                                                        : item.moduleID === 16
                                                                            ? generatePath(RouteConstants.EVENT_STAFF_SCHEDULE, {
                                                                                eventID: item.eventID,
                                                                            })
                                                                            : item.moduleID === 18
                                                                                ? generatePath(
                                                                                    RouteConstants.EVENT_ALLSTAR_REGISTER_CREATE,
                                                                                    {
                                                                                        eventID: item.eventID,
                                                                                    }
                                                                                )
                                                                                : item.moduleID === 17
                                                                                    ? generatePath(
                                                                                        Helper.isAdminUser(userInfo)
                                                                                            ? RouteConstants.All_STAR_TIKCET
                                                                                            : RouteConstants.All_STAR_END_USER_TIKCETS,
                                                                                        {
                                                                                            eventID: item.eventID,
                                                                                        }
                                                                                    )
                                                                                    : item.moduleID === 20
                                                                                        ? generatePath(
                                                                                            Helper.isAdminUser(userInfo)
                                                                                                ? RouteConstants.DRAFT_EVENT_TRANSIT_LIST
                                                                                                : RouteConstants.DRAFT_EVENT_TRANSIT,
                                                                                            {
                                                                                                eventID: item.eventID,
                                                                                            }
                                                                                        )
                                                                                        : item.moduleID === 21
                                                                                            ? generatePath(
                                                                                                Helper.isAdminUser(userInfo)
                                                                                                    ? RouteConstants.DRAFT_COMBINE_EVENT_TRANSIT_LIST
                                                                                                    : RouteConstants.DRAFT_COMBINE_EVENT_TRANSIT,
                                                                                                {
                                                                                                    eventID: item.eventID,
                                                                                                }
                                                                                            ) : item.moduleID === 25
                                                                                                ? generatePath(
                                                                                                    Helper.isAdminUser(userInfo)
                                                                                                        ? RouteConstants.CREDENTIAL_LIST
                                                                                                        : RouteConstants.CREDENTIALS,
                                                                                                    {
                                                                                                        eventID: item.eventID,
                                                                                                    }
                                                                                                ) : item.moduleID === 26
                                                                                                    ? generatePath(
                                                                                                        Helper.isAdminUser(userInfo)
                                                                                                            ? RouteConstants.COMBINE_FLIGHT_INFOLIST
                                                                                                            : RouteConstants.COMBINE_FLIGHT_INFO,
                                                                                                        {
                                                                                                            eventID: item.eventID,
                                                                                                        }
                                                                                                    ) : item.moduleID === 27
                                                                                                    ? generatePath(
                                                                                                        Helper.isAdminUser(userInfo)
                                                                                                            ? RouteConstants.LUNCHROOM_LIST
                                                                                                            : RouteConstants.LUNCHROOM,
                                                                                                        {
                                                                                                            eventID: item.eventID,
                                                                                                        }
                                                                                                    ) : item.moduleID === 28
                                                                                                    ? generatePath(
                                                                                                        Helper.isAdminUser(userInfo)
                                                                                                            ? RouteConstants.GREENROOM_LIST
                                                                                                            : RouteConstants.GREENROOM,
                                                                                                        {
                                                                                                            eventID: item.eventID,
                                                                                                        }
                                                                                                    ) : null;
        return path;
    }

    return (
        <Box className={loading.get() ? 'alignCenter' : 'otherContentBox'}>
            {loading.get() ? (
                <Box className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) : (
                <DataList
                    data={notificationList.attach(Downgraded).get()}
                    title={'App Notification'}
                    // onCheckSelect={props.onCheckSelect}
                    showTopbar={false}
                    onDelete={onDelete}
                    updateNotifications={updateNotifications}
                    showSearch={false}
                    refresh={getInAppNotifications}
                    handleAppNotificationClick={handleAppNotificationClick}
                    label={'appNotification'}
                />
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
            {
                <ConfirmationDialog
                    open={deleteConfirmation.get().open}
                    message={deleteConfirmation.get().message}
                    OkButtonText={deleteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleConfirmation(deleteConfirmation)
                    }
                    onCancelClick={() => {
                        deleteConfirmation.set({
                            ...deleteConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
        </Box>
    );
};

export default {
    routeProps: {
        path: RouteConstants.IN_APP_NOTIFICATIONS,
        component: AppNotifications,
    },
    name: 'AppNotifications',
};
